import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'form-fullScreen': _ctx.isEdit })
  }, [
    _withDirectives(_createElementVNode("div", null, [
      _withDirectives((_openBlock(), _createBlock(_component_TableList, {
        dataList: _ctx.list,
        total: _ctx.total,
        columnAllData: _ctx.columnAllData,
        page: _ctx.listQuery.page,
        size: _ctx.listQuery.size,
        showSelection: false,
        canRefresh: false,
        canChangeColumn: false,
        isShowPagination: false,
        tableName: _ctx.TableName,
        permissionName: _ctx.permissionName,
        showSummary: true,
        canCommand: _ctx.marketFeeCanCommand,
        onCommandChange: _ctx.handleCommand
      }, {
        "operation-action": _withCtx((scope) => [
          (scope.row.editable)
            ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                key: 0,
                href: "javascript:void(0);",
                class: "mr-10",
                type: "primary",
                onClick: ($event: any) => (_ctx.handleCommand('edit', scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("table.edit")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, { pkey: `${_ctx.permissionName}_EDIT_MARKET_FEE` }]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataList", "total", "columnAllData", "page", "size", "tableName", "permissionName", "canCommand", "onCommandChange"])), [
        [_directive_loading, _ctx.listLoading]
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.activeId)
            ? (_openBlock(), _createBlock(_component_FormComponent, {
                key: 0,
                id: _ctx.activeId,
                initFormData: _ctx.initFormData,
                fromFieldData: _ctx.fromFieldData,
                dialogFormVisible: _ctx.dialogFormVisible,
                api: _ctx.addPathApi,
                method: "PUT",
                businessDetail: _ctx.businessDetail,
                handleResolveTempData: _ctx.handleResolveTempData,
                "onUpdate:visibel": _cache[0] || (_cache[0] = ($event: any) => {_ctx.dialogFormVisible = false;_ctx.isEdit = false}),
                onSubmit: _cache[1] || (_cache[1] = ($event: any) => {_ctx.handleSubmit(_ctx.formData);_ctx.isEdit = false})
              }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "api", "businessDetail", "handleResolveTempData"]))
            : (_openBlock(), _createBlock(_component_FormComponent, {
                key: 1,
                id: _ctx.activeId,
                initFormData: _ctx.initEditFromData,
                fromFieldData: _ctx.editFromData,
                dialogFormVisible: _ctx.dialogFormVisible,
                api: _ctx.editPathPai,
                businessDetail: _ctx.businessDetail,
                "onUpdate:visibel": _cache[2] || (_cache[2] = ($event: any) => {_ctx.dialogFormVisible = false;_ctx.isEdit = false}),
                onSubmit: _cache[3] || (_cache[3] = ($event: any) => {_ctx.handleSubmit(_ctx.formData);_ctx.isEdit = false})
              }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "api", "businessDetail"]))
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}